import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"
import { FontAwesomeIcon, MediaFlex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

import WizardLoading from "./loaders/wizard-loading"
import AccordionContent from "./wizard-options/accordion-content"
import AccordionHeading from "./wizard-options/accordion-heading"

const Container = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.grey[400]};
  overflow: hidden;
  ${(props) => props.theme.mediaQueries.tablet`
    border: none;
  `}
`

const InternalWizardOptions = ({
  adminMode,
  excludeChoiceOption,
  prefOrder,
  wizardLoading,
}) => (
  <Container>
    <MediaFlex alignItems="center" lessThan="tablet" py="12px">
      <FontAwesomeIcon
        color="primary"
        fontSize="12px"
        icon={faDiamond}
        mr="6px"
      />
      <Typography as="h2" fontSize="16px" fontWeight="600">
        {jewlr_t("terms.Personalize")} It
      </Typography>
    </MediaFlex>
    {wizardLoading ? (
      <WizardLoading />
    ) : (
      prefOrder
        .filter(
          (pref) =>
            !(adminMode && pref == "gift") &&
            !(excludeChoiceOption && pref === "o1")
        )
        .map((pref) => (
          <div data-cy={`wizard-accordion-${pref}`} key={`wopt-${pref}`}>
            <AccordionHeading pref={pref} />
            <AccordionContent panel={pref} pref={pref} />
          </div>
        ))
    )}
  </Container>
)

InternalWizardOptions.propTypes = {
  adminMode: PropTypes.bool,
  excludeChoiceOption: PropTypes.bool,
  prefOrder: PropTypes.array,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  const numStonesExp = state.experiment.numStones.variant_id
  const styleCode = state.wizard.description.style_code
  const excludeChoiceOption =
    numStonesExp === 1 && ["JWL0124", "JWL0018", "JWL1053"].includes(styleCode)
  return {
    adminMode: state.wizard.adminMode,
    excludeChoiceOption,
    prefOrder: state.wizard.prefOrder,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

const WizardOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardOptions)

export default WizardOptions
